import { IncidentStatus } from '../../pages/law/incidentsData';

export function getIncidentStatusTone(status: IncidentStatus) {
  if (status === 'active') return 'danger';
  if (status === 'acknowledged') return 'warn';
  return 'success';
}

export function getIncidentMarkerColor(status: IncidentStatus) {
  if (status === 'active') return 'var(--danger)';
  if (status === 'acknowledged') return 'var(--warn)';
  return 'var(--success)';
}
